module.exports = __webpack_public_path__ + "img/score.82300f37.png";